/* eslint-disable */
import { log as debugLog, warn as debugWarn, error as debugError } from '@/utils/debugLogger';

const OriginalImage = window.Image;

export default {
	install(app, options) {
		debugLog('installing priority-image plugin');
		Object.defineProperty(HTMLImageElement.prototype, 'src', {
			set: function (value) {
				let tiles = value.includes('Tiles');
				if (typeof value === 'string' && tiles) {
					this.fetchPriority = 'high';
				}
				// Use the original setAttribute method:
				this.setAttribute('src', value);
			},
			get: function () {
				return this.getAttribute('src');
			},
			configurable: true,
			enumerable: true
		});
	}
};